import type { InjectionKey } from "vue";

/**
 * Injection key for reporting user activity (typing, clicking) to the form
 * renderer's idle-timeout tracker.
 *
 * The renderer normally detects activity via `@keydown.capture` / `@mousedown.capture`
 * on the form host element. However, components that render their editable surface
 * inside an `<iframe>` (e.g. the TinyMCE RichText editor) trap keystrokes in a
 * separate document, so those capture handlers never fire. Such components should
 * inject this reporter and call it on their own key/input events to keep the idle
 * timer alive while the user is actively typing.
 */
export const formActivityInjectKey: InjectionKey<() => void> =
  Symbol("formActivity");
